"use strict";

module.exports = [{
  label: 'Ambient',
  value: 'AMBIENT'
}, {
  label: 'Above Ambient',
  value: 'ABOVE_AMBIENT'
}, {
  label: 'Below Ambient',
  value: 'BELOW_AMBIENT'
}];